import { createStyles, makeStyles } from '@material-ui/styles';
import SpringBackgroundPattern from '../../../assets/background/loginLayout/loginBackgroundSpring.svg';
import AutumnBackgroundPattern from '../../../assets/background/loginLayout/loginBackgroundAutumn.svg';
import palette from '../../../theme/palette';
import { CURRENT_CHALLENGE_SEASON } from 'helpers/challenge/getChallengeInfos';

const style = () =>
  createStyles({
    root: {
      color: palette.text.white,
      backgroundImage: `url(${
        CURRENT_CHALLENGE_SEASON === 'autumn'
          ? AutumnBackgroundPattern
          : SpringBackgroundPattern
      })`,
      backgroundSize: 'cover',
      height: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px'
    },
    status: {
      fontSize: '7rem'
    },
    text: {
      fontSize: '1.5rem',
      padding: '10px',
      textAlign: 'center'
    },
    extra: {
      fontSize: '1rem',
      padding: '10px',
      textAlign: 'center'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
